import React from 'react';

export default ({ color = '#5E5E5E', size = 18 }: { color: string; size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8005 5.625C14.5537 6.62779 15 7.87428 15 9.225C15 12.5387 12.3137 15.225 9 15.225C5.6863 15.225 3 12.5387 3 9.225C3 7.87428 3.44633 6.62779 4.19956 5.625"
      stroke={color}
      strokeWidth="1.92"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 6.82539V2.02539"
      stroke={color}
      strokeWidth="1.92"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
